import { z } from 'zod';

export const clientRepResDto = z.object({
  id: z.string(),
  clientId: z.string(),
  // we only parse the required fields
});
